var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: {
                title: "BankSlip Upload(KR)",
                isShowFollow: false,
                width: "80%",
              },
              on: { open: _vm.opened, close: _vm.closed },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c(
              "div",
              { staticClass: "filter-container-content" },
              [
                _c(
                  "el-form",
                  { ref: "form", attrs: { model: _vm.form, rules: _vm.rules } },
                  [
                    _c(
                      "table",
                      {
                        staticClass: "mailTable",
                        staticStyle: { width: "100%", "margin-bottom": "0" },
                      },
                      [
                        _c("colgroup", [
                          _c("col", { attrs: { width: "140px" } }),
                          _vm._v(" "),
                          _c("col", { attrs: { width: "140px" } }),
                          _vm._v(" "),
                          _c("col", { attrs: { width: "140px" } }),
                          _vm._v(" "),
                          _c("col", { attrs: { width: "140px" } }),
                          _vm._v(" "),
                          _c("col", { attrs: { width: "140px" } }),
                          _vm._v(" "),
                          _c("col", { attrs: { width: "140px" } }),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c(
                            "td",
                            { staticClass: "column", attrs: { colspan: "4" } },
                            [
                              _c("span", { staticClass: "column-after" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("importBillUpload.paymentNo"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "light",
                                    content: _vm.form.paymentNo,
                                    placement: "right",
                                  },
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "paymentNo" } },
                                    [
                                      _c("el-input", {
                                        attrs: { disabled: "" },
                                        model: {
                                          value: _vm.form.paymentNo,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "paymentNo", $$v)
                                          },
                                          expression: "form.paymentNo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "p-color" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "exportCostSlipUpload.payeeContactShipping"
                                    )
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c(
                            "td",
                            { staticClass: "column", attrs: { colspan: "6" } },
                            [
                              _c("span", { staticClass: "column-after" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("importBillUpload.paymentWay"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { prop: "paymentWay" } },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      on: { change: _vm.handleChange },
                                      model: {
                                        value: _vm.form.paymentWay,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "paymentWay", $$v)
                                        },
                                        expression: "form.paymentWay",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "05" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "importBillUpload.paymentInKrw"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "06" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "importBillUpload.paymentInUsd"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "04" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "importBillUpload.originalCurrencyPay"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "p-color" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "exportCostSlipUpload.specialPaymentContact"
                                    )
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c(
                            "td",
                            { staticClass: "column ", attrs: { colspan: "1" } },
                            [
                              _c("span", { staticClass: "column-after" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("exportCostSlipUpload.amount"))
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("tr", { key: _vm.form.paymentWay }, [
                          _vm.form.paymentWay == "05"
                            ? _c(
                                "td",
                                {
                                  staticClass: "column ",
                                  attrs: { colspan: "1" },
                                },
                                [
                                  _c("span", { staticClass: "column-after" }, [
                                    _vm._v("KRW"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "amountAllKRW" } },
                                    [
                                      _c("el-input", {
                                        attrs: { disabled: "" },
                                        model: {
                                          value: _vm.form.amountAllKRW,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "amountAllKRW",
                                              $$v
                                            )
                                          },
                                          expression: "form.amountAllKRW",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.paymentWay == "05"
                            ? _c(
                                "td",
                                {
                                  staticClass: "column ",
                                  attrs: { colspan: "1" },
                                },
                                [
                                  _c("span"),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticStyle: { "margin-top": "30px" },
                                      attrs: { prop: "amountKRWFileId" },
                                    },
                                    [
                                      _c(
                                        "el-upload",
                                        {
                                          ref: "upload",
                                          staticClass: "upload-demo",
                                          attrs: {
                                            action: "",
                                            multiple: "",
                                            limit: 1,
                                            "http-request":
                                              _vm.uploadAmountAllKRWFile,
                                            "on-remove":
                                              _vm.handleAmountAllKRWFile,
                                            "before-remove": _vm.beforeRemove,
                                            accept: _vm.acceptList,
                                            "file-list":
                                              _vm.amountAllKRWFileList,
                                          },
                                          model: {
                                            value: _vm.form.amountKRWFileId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "amountKRWFileId",
                                                $$v
                                              )
                                            },
                                            expression: "form.amountKRWFileId",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                disabled:
                                                  _vm.form.amountAllKRW == 0,
                                                icon: "el-icon-upload2",
                                                size: "small",
                                                type: "primary",
                                                plain: "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.selectFile"
                                                  )
                                                ) + "\n                    "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.paymentWay == "06"
                            ? _c(
                                "td",
                                {
                                  staticClass: "column ",
                                  attrs: { colspan: "1" },
                                },
                                [
                                  _c("span", { staticClass: "column-after" }, [
                                    _vm._v("USD"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "amountAllUSD" } },
                                    [
                                      _c("el-input", {
                                        attrs: { disabled: "" },
                                        model: {
                                          value: _vm.form.amountAllUSD,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "amountAllUSD",
                                              $$v
                                            )
                                          },
                                          expression: "form.amountAllUSD",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.paymentWay == "06"
                            ? _c(
                                "td",
                                {
                                  staticClass: "column ",
                                  attrs: { colspan: "1" },
                                },
                                [
                                  _c("span"),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticStyle: { "margin-top": "30px" },
                                      attrs: { prop: "amountUSDFileId" },
                                    },
                                    [
                                      _c(
                                        "el-upload",
                                        {
                                          ref: "upload",
                                          staticClass: "upload-demo",
                                          attrs: {
                                            action: "",
                                            multiple: "",
                                            limit: 1,
                                            "http-request":
                                              _vm.uploadAmountAllUSDFile,
                                            "on-remove":
                                              _vm.handleAmountAllUSDFile,
                                            "before-remove": _vm.beforeRemove,
                                            accept: _vm.acceptList,
                                            "file-list":
                                              _vm.amountAllUSDFileList,
                                          },
                                          model: {
                                            value: _vm.form.amountUSDFileId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "amountUSDFileId",
                                                $$v
                                              )
                                            },
                                            expression: "form.amountUSDFileId",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                disabled:
                                                  _vm.form.amountAllUSD == 0,
                                                icon: "el-icon-upload2",
                                                size: "small",
                                                type: "primary",
                                                plain: "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.selectFile"
                                                  )
                                                ) + "\n                    "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.paymentWay == "04"
                            ? _c(
                                "td",
                                {
                                  staticClass: "column ",
                                  attrs: { colspan: "1" },
                                },
                                [
                                  _c("span", { staticClass: "column-after" }, [
                                    _vm._v("KRW"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "amountKRW" } },
                                    [
                                      _c("el-input", {
                                        attrs: { disabled: "" },
                                        model: {
                                          value: _vm.form.amountKRW,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "amountKRW", $$v)
                                          },
                                          expression: "form.amountKRW",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.paymentWay == "04"
                            ? _c(
                                "td",
                                {
                                  staticClass: "column ",
                                  attrs: { colspan: "1" },
                                },
                                [
                                  _c("span"),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticStyle: { "margin-top": "30px" },
                                      attrs: { prop: "amountKRWFileId" },
                                    },
                                    [
                                      _c(
                                        "el-upload",
                                        {
                                          ref: "upload",
                                          staticClass: "upload-demo",
                                          attrs: {
                                            action: "",
                                            multiple: "",
                                            limit: 1,
                                            "http-request":
                                              _vm.uploadAmountAllKRWFile,
                                            "on-remove":
                                              _vm.handleAmountAllKRWFile,
                                            "before-remove": _vm.beforeRemove,
                                            accept: _vm.acceptList,
                                            "file-list":
                                              _vm.amountAllKRWFileList,
                                          },
                                          model: {
                                            value: _vm.form.amountKRWFileId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "amountKRWFileId",
                                                $$v
                                              )
                                            },
                                            expression: "form.amountKRWFileId",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                disabled:
                                                  _vm.form.amountKRW == 0,
                                                icon: "el-icon-upload2",
                                                size: "small",
                                                type: "primary",
                                                plain: "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.selectFile"
                                                  )
                                                ) + "\n                    "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.paymentWay == "04"
                            ? _c(
                                "td",
                                {
                                  staticClass: "column ",
                                  attrs: { colspan: "1" },
                                },
                                [
                                  _c("span", { staticClass: "column-after" }, [
                                    _vm._v("USD"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "amountUSD" } },
                                    [
                                      _c("el-input", {
                                        attrs: { disabled: "" },
                                        model: {
                                          value: _vm.form.amountUSD,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "amountUSD", $$v)
                                          },
                                          expression: "form.amountUSD",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.paymentWay == "04"
                            ? _c(
                                "td",
                                {
                                  staticClass: "column ",
                                  attrs: { colspan: "1" },
                                },
                                [
                                  _c("span"),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticStyle: { "margin-top": "30px" },
                                      attrs: { prop: "amountUSDFileId" },
                                    },
                                    [
                                      _c(
                                        "el-upload",
                                        {
                                          ref: "upload",
                                          staticClass: "upload-demo",
                                          attrs: {
                                            action: "",
                                            multiple: "",
                                            limit: 1,
                                            "http-request":
                                              _vm.uploadAmountAllUSDFile,
                                            "on-remove":
                                              _vm.handleAmountAllUSDFile,
                                            "before-remove": _vm.beforeRemove,
                                            accept: _vm.acceptList,
                                            "file-list":
                                              _vm.amountAllUSDFileList,
                                          },
                                          model: {
                                            value: _vm.form.amountUSDFileId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "amountUSDFileId",
                                                $$v
                                              )
                                            },
                                            expression: "form.amountUSDFileId",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                disabled:
                                                  _vm.form.amountUSD == 0,
                                                icon: "el-icon-upload2",
                                                size: "small",
                                                type: "primary",
                                                plain: "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.selectFile"
                                                  )
                                                ) + "\n                    "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c(
                            "td",
                            { staticClass: "column", attrs: { colspan: "8" } },
                            [
                              _c("span", { staticClass: "column-after" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("importBillUpload.remark"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { prop: "remark" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      maxLength: "500",
                                      autosize: { minRows: 2, maxRows: 4 },
                                    },
                                    model: {
                                      value: _vm.form.remark,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "remark", $$v)
                                      },
                                      expression: "form.remark",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c(
                            "td",
                            { staticClass: "column", attrs: { colspan: "2" } },
                            [
                              _c("span", { staticClass: "column-after" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("importBillUpload.emailAddress")
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { prop: "email" } },
                                [
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "uppercase",
                                        rawName: "v-uppercase",
                                      },
                                      { name: "trim", rawName: "v-trim" },
                                      { name: "fth", rawName: "v-fth" },
                                    ],
                                    attrs: { maxLength: "200" },
                                    model: {
                                      value: _vm.form.email,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "email", $$v)
                                      },
                                      expression: "form.email",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "column", attrs: { colspan: "2" } },
                            [
                              _c("span", { staticClass: "column-after" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("importBillUpload.contactPerson")
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { prop: "contactPerson" } },
                                [
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "uppercase",
                                        rawName: "v-uppercase",
                                      },
                                      { name: "trim", rawName: "v-trim" },
                                      { name: "fth", rawName: "v-fth" },
                                    ],
                                    attrs: { maxLength: "200" },
                                    model: {
                                      value: _vm.form.contactPerson,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "contactPerson", $$v)
                                      },
                                      expression: "form.contactPerson",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "item-button" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-primary",
                            on: { click: _vm.handleSave },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("btn.save")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }